import axios from "axios";
import Links from "../constants/Links";

/**
 * This is the Admission Quota API hook for handling admission quota management
 * (C) 2021-2025
 */
const AdmissionQuota = {
    /**
     * Get quota statistics for an admission period
     * @param {string} admissionId the admission period ID
     * @returns {Promise<object>} quota statistics data
     */
    getStatistics: async (admissionId) => {
        return axios.get(Links.admissionQuota.statistics + admissionId)
    },

    /**
     * Create or update a quota for a programme
     * @param {object} data quota data containing programmeId, maxApplicants, notes, isActive, admissionId
     * @returns {Promise<object>} created/updated quota
     */
    saveQuota: async (data) => {
        return axios.post(Links.admissionQuota.quota, data)
    },

    /**
     * Get current global quota configuration
     * @returns {Promise<object>} current global configuration
     */
    getGlobalConfig: async () => {
        return axios.get(Links.admissionQuota.globalConfig)
    },

    /**
     * Save global quota configuration
     * @param {object} data global config data containing indigenousPercentage, nonIndigenousPercentage, etc.
     * @returns {Promise<object>} saved global configuration
     */
    saveGlobalConfig: async (data) => {
        return axios.post(Links.admissionQuota.globalConfig, data)
    },

    /**
     * Process admission quota for a specific programme
     * @param {string} admissionId the admission period ID
     * @param {string} programmeId the programme ID
     * @returns {Promise<object>} processing result
     */
    processProgramme: async (admissionId, programmeId) => {
        return axios.post(`${Links.admissionQuota.process}${admissionId}/programme/${programmeId}`)
    },

    /**
     * Process admission quota for all programmes in an admission period
     * @param {string} admissionId the admission period ID
     * @returns {Promise<object>} processing results for all programmes
     */
    processAllProgrammes: async (admissionId) => {
        return axios.post(`${Links.admissionQuota.processAll}${admissionId}/all`)
    }
}

export default AdmissionQuota